import DoneIcon from '@mui/icons-material/Done';

export const CheckIcon = DoneIcon;
